<template>
    <b-container class="main-area">
        <el-main :class="{ overLayShadow: isOpenOverLayShadow }">
            <div class="toolbar hidden-sm-and-down">
                <div class="total">
                    {{ $tc('searchResultPage.resultCount', count | NumFormat ) }}
                    <span
                        v-if="region.name"
                    >• {{region.name}}</span>
                </div>
            </div>

            <div class="noResult" v-if="count == 0">
                <h2>{{ $t('searchResultPage.noResult', { region: region.name } ) }}</h2>
                <p>{{$t("searchResultPage.resultHint")}}</p>
                <el-button
                    class="noResult_button"
                    type="button"
                    @click="clearAllFilter"
                >{{$t("searchResultPage.removeFilters")}}</el-button>
            </div>

            <el-row :gutter="28">
                <el-col
                    :span="8"
                    :xs="24"
                    :sm="12"
                    :md="8"
                    :lg="8"
                    v-for="item in projects"
                    :key="item.id"
                    style="margin-bottom: 20px;"
                >
                    <el-card
                        :body-style="{ padding: '0px'}"
                        shadow="never"
                        :class="{iconCrown: item.top_10}"
                    >
                        <div class="carousel">
                            <el-carousel height="203px" width="360" :autoplay="false">
                                <el-carousel-item
                                    v-for="(pic, index) in item.pictures"
                                    :key="index"
                                >
                                    <a :href="item.url" target="_blank">
                                        <el-image :src="pic" @error="errorImg" alt="project images">
                                            <div slot="placeholder" class="image-slot">
                                                {{$t("searchResultPage.loading")}}<span class="dot">...</span>
                                            </div>
                                        </el-image>
                                    </a>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <a :href="item.url" target="_blank">
                            <div class="block">
                                <div class="avg_price">{{ item.avg_sqft_price }}</div>
                                <span class="name" target="_blank">{{ item.name }}</span>
                                <div class="region">{{ item.region }}</div>
                                <div
                                    class="min_price"
                                >{{$t('searchResultPage.card.startingPrice')}} {{ item.min_unit_price }}</div>
                                <div class="livable_score" v-if="item.score">
                                    <el-progress
                                        type="circle"
                                        :percentage="parseFloat(item.score)"
                                        :show-text="false"
                                        color="#447ef6"
                                        :stroke-width="5"
                                        :width="70"
                                    ></el-progress>
                                    <div class="score">{{ item.score }}</div>
                                    <p>{{$t('searchResultPage.overall')}}</p>
                                </div>
                            </div>
                        </a>
                    </el-card>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" :offset="6" class="text-center" v-if="!isHideLoadMore">
                    <el-button class="load_more" @click="loadMore">
                        <i></i>
                        {{$t('searchResultPage.loadMore')}}
                    </el-button>
                </el-col>
            </el-row>
        </el-main>
    </b-container>
</template>
<script>
import defaultImg from "../../../website_20/static/img/default-no-img.svg";

export default {
    name: "SearchResultList",
    props: [
        "projects",
        "isOpenOverLayShadow",
        "count",
        "region",
        "isHideLoadMore"
    ],
    data() {
        return {};
    },

    methods: {
        switchView() {
            this.$emit("view", "map");
        },

        clearAllFilter() {
            this.$emit("clearAll", true);
        },

        loadMore() {
            this.$emit("loadMoreData", true);
        },

        errorImg(param) {
            param.target.src = `${defaultImg}`;
        },

        NumFormat(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    filters: {
        NumFormat(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
};
</script>

<style scoped>
.overLayShadow {
    position: relative;
}

.overLayShadow:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4;
    background: rgba(255, 255, 255, 0.85);
}

.toolbar {
    height: 0.48rem;
    margin: 15px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.toolbar .total {
    display: inline-block;
    font-size: 0.16rem;
    color: rgb(51, 51, 51);
}

.main-area >>> .el-card.iconCrown {
    position: relative;
}

.main-area >>> .el-card.iconCrown:before {
    content: "";
    position: absolute;
    right: -50px;
    top: -50px;
    display: inline-block;
    z-index: 2;
    width: 100px;
    height: 100px;
    transform: rotate(45deg);
    background-color: #0d253f;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}

.main-area >>> .el-card.iconCrown:after {
    content: "";
    position: absolute;
    right: 10px;
    top: 12px;
    display: inline-block;
    z-index: 2;
    width: 24px;
    height: 20px;
    background: url("../../../website_20/static/img/stacked-group-4.svg")
        no-repeat;
    background-position: 2px -2px;
}

.main-area >>> .el-card {
    border: 0;
    border-radius: 6px;
    height: 350px;
}

.main-area >>> .el-card img {
    height: 203px;
    width: 100%;
    object-fit: cover;
}

.main-area >>> .el-card .block {
    position: relative;
}

.main-area >>> .el-card .block .livable_score {
    position: absolute;
    right: 0;
    top: 0;
}

.main-area >>> .el-card .block .score {
    font-family: GothamBold;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.4px;
    text-align: center;
    color: rgb(12, 37, 61);
    position: absolute;
    top: 24px;
    left: 16px;
}

.main-area >>> .el-card .block .livable_score p {
    font-family: GothamMedium;
    font-size: 10px;
    font-weight: 500;
    margin-top: 12px;
    text-align: center;
    color: var(--brownish-grey);
}

.main-area >>> .el-card .block svg {
    height: auto;
    width: auto;
}

.el-card .block .avg_price {
    font-family: GothamBold;
    font-weight: bold;
    color: rgb(51, 51, 51);
    margin: 10px 0;
    height: 0.19rem;
}

.el-card .block .name {
    font-family: GothamBold;
    font-size: 0.18rem;
    font-weight: bold;
    min-height: 0.18rem;
    letter-spacing: 0.8px;
    color: rgb(51, 51, 51);
    margin-bottom: 0.05rem;
    display: block;
    max-width: 275px;
    height: auto;
    word-break: break-word;
}

.el-card .block .region {
    font-size: 0.14rem;
    letter-spacing: 0.6px;
    height: 0.18rem;
    color: #666;
    margin-bottom: 0.1rem;
}

.el-card .block .min_price {
    font-family: GothamBook;
    font-size: 0.12rem;
    line-height: 1.05;
    color: #666;
    height: 0.13rem;
    margin-bottom: 0.1rem;
}

.noResult {
    padding-bottom: 20px;
    margin-bottom: 35px;
    border-bottom: 1px solid #d8d8d8;
}

.noResult h2 {
    font-family: GothamBold;
    font-size: 22px;
    font-weight: bold;
    line-height: 22px;
    color: rgb(51, 51, 51);
}

.noResult p {
    margin-top: 5px;
    font-family: GothamBook;
    font-size: 16px;
    line-height: 45px;
    color: rgb(51, 51, 51);
}

.noResult .el-button {
    height: 40px;
    box-shadow: 0 8px 15px 0 rgba(127, 156, 207, 0.5);
    padding: 0;
    border: 0;
    background-color: var(--windows-blue);
    width: 180px;
    font-family: GothamMedium;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-align: center;
    color: var(--white);
    margin-top: 20px;
}

.noResult .el-button >>> span {
    font-family: GothamBook;
    display: inline-block;
    vertical-align: middle;
}

.noResult .el-button:hover {
    background-color: var(--light-navy);
}

.carousel >>> .el-carousel__container {
    z-index: 1;
}

.carousel >>> .el-carousel__item {
    border-radius: 6px;
}

.carousel >>> .el-carousel__item a {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.image-slot {
    color: #9b9b9b;
}

.load_more {
    font-family: GothamBook;
    font-size: 16px;
    letter-spacing: 0.4px;
    color: var(--white);
    width: 2rem;
    height: 0.4rem;
    text-align: center;
    color: #3b6bbf;
    border: 1.9px solid #3b6bbf;
}

.load_more i {
    display: inline-block;
    vertical-align: bottom;
    width: 12px;
    height: 15px;
    margin-right: 15px;
    overflow: hidden;
    background: url("../../../website_20/static/img/combined-shape-normal.svg")
        no-repeat;
    background-position: 0 0;
}

.load_more:hover {
    background-color: #3b6bbf;
    color: #fff;
}

.load_more:hover i {
    background: url("../../../website_20/static/img/combined-shape-hover.svg")
        no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchResultList.vue